import { OptimizelyPromoBlock } from '../../types/optimizely/blocks/promoBlock';
import { PromoBlockProps } from '../../components/HelpPages/organisms/PromoBlock';

export const mapToPromoCard = (
	optiBlock: OptimizelyPromoBlock,
): PromoBlockProps => {
	return {
		url: optiBlock.titleLink.value || '',
		title: optiBlock.title.value || '',
		...(optiBlock.image && {
			image: {
				src: optiBlock.image?.value?.url || '',
				alt: optiBlock.image?.expandedValue?.alt?.value || '',
			},
		}),
		...(optiBlock.textEditor && {
			content: optiBlock.textEditor.value,
		}),
		anchorId: optiBlock.anchorId,
	};
};
